import { ChevronsUp, Minus, ChevronsDown, Equal, EqualIcon } from 'lucide-react';
import { getConfigData, getAgencyData } from './Storage';
import { SEGMENT_CONFIG } from '../Components/Enums/DataEnums';


export const priorityConfig = {
    'H': {
        value: 'H',
        label: 'High',
        color: '#bf5700',
        bgColor: '#bf570015',
        borderColor: '#bf570030',
        class: 'text-[#bf5700] bg-[#bf570015] border-[#bf570030]',
        icon: ChevronsUp,
        showBadge: true
    },
    'M': {
        value: 'M',
        label: 'Normal',
        color: '#808080',
        bgColor: '#80808015',
        borderColor: '#80808030',
        class: 'text-[#808080] bg-[#80808015] border-[#80808030]',
        icon: Equal,
        showBadge: false
    },
    'L': {
        value: 'L',
        label: 'Low',
        color: '#0c6980',
        bgColor: '#0c698015',
        borderColor: '#0c698030',
        class: 'text-[#0c6980] bg-[#0c698015] border-[#0c698030]',
        icon: ChevronsDown,
        showBadge: false
    }
};

// Aliases for convenience
priorityConfig['High'] = priorityConfig['H'];
priorityConfig['Normal'] = priorityConfig['M'];
priorityConfig['Medium'] = priorityConfig['M'];
priorityConfig['Low'] = priorityConfig['L'];

export const getPriorityDetails = (priorityValue) => {
    if (!priorityValue) return priorityConfig['M'];

    // Try exact lookup first
    if (priorityConfig[priorityValue]) return priorityConfig[priorityValue];

    // Normalise casing
    const normalised = String(priorityValue).trim();
    if (priorityConfig[normalised]) return priorityConfig[normalised];

    // Try first letter uppercase
    const firstLetter = normalised.charAt(0).toUpperCase();
    if (priorityConfig[firstLetter]) return priorityConfig[firstLetter];

    return priorityConfig['M'];
};

export const priorities = [
    { label: 'High', value: 'H', color: 'text-[#bf5700] bg-[#bf570015] border-[#bf570030]' },
    { label: 'Medium', value: 'M', color: 'text-[#d97706] bg-[#d9770615] border-[#d9770630]' },
    { label: 'Low', value: 'L', color: 'text-[#007aff] bg-[#007aff15] border-[#007aff30]' }
];

export const taskTypes = [
    { value: "call", label: "Call" },
    { value: "meeting", label: "Meeting" },
    { value: "message", label: "Message" },
    { value: "visit", label: "Visit" },
];

export const taskStatus = [
    { value: 1, label: "Pending" },
    { value: 2, label: "Done" },
    { value: 3, label: "Cancelled" },
];

export const APP_VERSION = "Version 2.2.0";

// Segment Wise Feature Access

export const getActiveAgencySegmentID = () => {
    try {
        return Number(getConfigData()?.SegmentID) || 0;
    } catch (err) {
        console.error('[getActiveAgencySegmentID] Error auto-fetching segment:', err);
        return 0;
    }
};

export const hasFeatureAccess = (featureName) => {
    const segId = getActiveAgencySegmentID();
    if (!segId) return false;

    return Object.values(SEGMENT_CONFIG).some(
        config => config.features?.includes(featureName) && (config.segmentIDs || config.segments)?.includes(segId)
    );
};

export { SEGMENT_CONFIG };

